import React from 'react';
import heart from './img/heart.svg';
import './Mission.css';

function Header(): JSX.Element {
  return (
    <div className="mission">
      <div className="mobile-visible hidden">
        <span className="mission-part">
          вдохновляем на развитие!
          <span className="heart-box">
            <img src={heart} alt="" />
          </span>
        </span>
      </div>
      <div className="mobile-hidden">
        <span className="mission-part">вдохновляем на развитие!</span>
        <span className="mission-part heart-box">
          <img src={heart} alt="" />
        </span>
      </div>
    </div>
  );
}

export default Header;
